import React, { useState } from 'react';
import PropTypes from 'prop-types';

import AddControl from 'components/add_control';
import Modal from './modal';

export default function AddCriticalDate({
  addCriticalDate,
  className,
  deal,
  displayAs,
  fields,
  setCriticalDate,
}) {
  const [showModal, setShowModal] = useState();
  const AddComponent = displayAs || AddControl;

  return <React.Fragment>
    <AddComponent aria-label="Add critical date" className={className} onClick={() => setShowModal(true)}>
      Add critical date
    </AddComponent>

    <Modal
      addCriticalDate={addCriticalDate}
      deal={deal}
      fields={fields}
      setCriticalDate={setCriticalDate}
      show={showModal}
      onHide={() => setShowModal(false)}
    />
  </React.Fragment>;
}

AddCriticalDate.propTypes = {
  addCriticalDate: PropTypes.func,
  className: PropTypes.string,
  deal: PropTypes.object,
  displayAs: PropTypes.elementType,
  fields: PropTypes.object,
  setCriticalDate: PropTypes.func,
};
